<h2 mat-dialog-title>Reconhecimento Facial</h2>

<div mat-dialog-content>
    <div class="content-facial-biometrics row">
        <div class="col-md-12">
            <p>
                <b class="yellow-text">Importante:</b> para que seja realizado o Reconhecimento Facial de forma correta,
                <b>não utilize acessórios como bonés, óculos de grau ou escuros, posicione o rosto na moldura conforme
                    ilustração
                    abaixo</b> e aguarde alguns segundos até que seja feito o reconhecimento.
            </p>
        </div>
        <div class="col-md-12">
            <img class="img-facial-biometrics" src="assets/images/Reconhecimento_Facial.png" />
        </div>
    </div>
</div>

<div mat-dialog-actions class="row">

    <div class="col-md-6">
        <button mat-flat-button (click)="clickTakePhoto()" color="primary" class="btn-block">
            Entendi!
        </button>
    </div>
    <div class="col-md-6">
        <button mat-flat-button (click)="close()" color="accent" class="btn-block">
            Cancelar
        </button>
    </div>
</div>